// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__pTIG+","Main__Title":"Header_Main__Title__lkKNk","Description":"Header_Description__XLUkc","Header__Image":"Header_Header__Image__VW7HE"};